import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="border-y border-line bg-canvasAlt" data-id="element-20" data-mp="gxzxleqj5fvr">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10" data-id="element-21" data-mp="vqjo9fwhtuwb">
        <Reveal className="flex flex-col items-center gap-3 text-center" data-id="element-22" data-mp="qsi22m3rtfgm">
          <div data-id="element-23" data-mp="14sj4w73liwyq">
            <p className="font-display text-xs font-bold uppercase tracking-[0.18em] text-accent" data-id="element-24" data-mp="14rzxhkbknqyy">
              Incluidos hoy
            </p>
            <h2 id="bonos" className="mt-1.5 font-display text-2xl md:text-3xl font-extrabold uppercase text-ink" data-id="element-25" data-mp="1ejdyxxn330uq">
              6 Bonos estratégicos
            </h2>
          </div>
          <p className="rounded-lg border border-accent/40 bg-accent-soft px-4 py-2 font-display text-sm font-bold uppercase text-accent" data-id="element-26" data-mp="1njalntpwxpn5">
            Valor total $53.000 → gratis hoy
          </p>
        </Reveal>

        <ul className="mt-5 grid gap-3 md:grid-cols-2 lg:grid-cols-3" data-id="element-27" data-mp="3prdbm17v8lsv">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-line bg-surface p-5" data-id="element-28" data-mp="3tsff4u8tfk0n" data-mpi={i}>
              <span className="flex items-center gap-1.5 font-display text-xs font-bold uppercase tracking-[0.14em] text-accent" data-id="element-29" data-mp="7m0fcpl4bwl6">
                <GiftIcon size={13} data-id="element-30" data-mp="gldofh5byj5d" />
                Bono {i + 1}
              </span>
              <h3 className="mt-1.5 font-display text-lg font-extrabold uppercase leading-tight text-ink" data-id="element-31" data-mp="gj0z2ix8t6ia">
                {bono.title}
              </h3>
              <p className="mt-2 mb-4 text-sm leading-relaxed text-ink-muted" data-id="element-32" data-mp="q9vkjl2o022o">
                {bono.desc}
              </p>
              <div className="mt-auto flex items-center justify-between gap-3 border-t border-line pt-3" data-id="element-33" data-mp="vc4g8p6x9i8h">
                <span className="text-sm text-ink-subtle line-through" data-id="element-34" data-mp="107a2jp48kyx3">
                  Valor {bono.value}
                </span>
                <span className="font-display text-sm font-extrabold uppercase text-success" data-id="element-35" data-mp="5me6y4aammxw">
                  Gratis
                </span>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}